<template>
  <div id="app">
    <v-app>
      <main class="main_shell">
        <app-header
          :current_step="app_step"
          :app_name="appName"
          :product="product"
        />
        <app-content
          v-on:step_changed="step_changed"
          :product="product"
          :exitUrl="exitUrl"
        />
        <app-footer :current_step="app_step" />
      </main>
    </v-app>
  </div>
</template>

<script>
import AppContent from "@/components/AppContent.vue";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  components: {
    appContent: AppContent,
    appHeader: AppHeader,
    appFooter: AppFooter,
  },
  data() {
    return {
      product: "beef",
      queryString: "",
      app_step: 0,
    };
  },
  computed: {
    appName: function appName() {
      return this.product === "dairy" ? "Dairy Direct" : "Sheep & Beef Direct";
    },
    exitUrl: function exitUrl() {
      return this.product === "dairy"
        ? process.env.DD_RETURN_URL
        : process.env.RETURN_URL;
    },
  },
  metaInfo() {
    return { title: this.appName + " Application" };
  },
  methods: {
    step_changed: function step_changed(val) {
      this.app_step = val;
    },
    parseLocationString: function parseLocationString(str) {
      if (str.indexOf("OriginWebpage") > -1 && str.indexOf("dairy") > 1) {
        this.product = "dairy";
      } else if (str.indexOf("OriginWebpage") > -1 && str.indexOf("beef") > 1) {
        this.product = "beef";
      }
    },
  },
  created: function() {
    this.product = process.env.PRODUCT ?? "beef";
    this.queryString = window.location.search;
    if (window.location.search) {
      this.parseLocationString(window.location.search);
    }
    window.trackingCode = this.product === "dairy" ? "dd" : "sb";
  },
};
</script>

<style></style>
